/* ============================================================
   NEUDERMA — Shopify theme behaviour
   Cart uses Shopify's AJAX Cart API (/cart/*.js).
   Drawer + menu markup is rendered by snippets (cart-drawer.liquid).
   ============================================================ */
(function () {
  'use strict';

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

 /* money: Shopify prices come in cents */
const fmt = cents => '$' + (cents / 100).toLocaleString('es-MX', {
  minimumFractionDigits: 2, maximumFractionDigits: 2
});

  const FREE_SHIP = (window.NEUDERMA && window.NEUDERMA.freeShip) || 3000; // cents

  /* ---------- open / close ---------- */
  const scrim = () => $('#nd-scrim');
  function openCart() { toggle($('#nd-cart'), true); refreshCart(); }
  function closeCart() { toggle($('#nd-cart'), false); }
  function openMenu() { toggle($('#nd-menu'), true); }
  function closeMenu() { toggle($('#nd-menu'), false); }
  function toggle(el, on) {
    if (!el) return;
    el.classList.toggle('open', on);
    el.setAttribute('aria-hidden', on ? 'false' : 'true');
    const anyOpen = $('#nd-cart')?.classList.contains('open') || $('#nd-menu')?.classList.contains('open');
    scrim()?.classList.toggle('open', anyOpen);
    document.body.style.overflow = anyOpen ? 'hidden' : '';
  }
  function closeAll() { toggle($('#nd-cart'), false); toggle($('#nd-menu'), false); }

  /* ---------- cart api ---------- */
  async function addToCart(id, qty) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      openCart();
    } catch (e) { console.warn('[Neuderma] add to cart:', e); }
  }
  async function changeLine(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      refreshCart();
    } catch (e) { console.warn('[Neuderma] change line:', e); }
  }
  async function refreshCart() {
    let cart;
    try { cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json(); }
    catch (e) { return; }
    renderCart(cart);
  }

  function renderCart(cart) {
    const n = cart.item_count;
    $$('.cart-count').forEach(el => { el.textContent = n; el.style.display = n ? 'flex' : 'none'; });
    const nEl = $('#nd-cart-n'); if (nEl) nEl.textContent = n;

    const items = $('#nd-cart-items');
    const foot = $('#nd-cart-foot');
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML = `<div class="cart-empty">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#9fb3a0" stroke-width="1.4"><path d="M6 7h12l-1 12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>
        <p>Tu carrito está vacío</p>
        <button class="btn btn--green" data-cart-close>Seguir comprando</button></div>`;
      foot.innerHTML = '';
      $$('[data-cart-close]', items).forEach(b => b.addEventListener('click', closeCart));
      updateShip(0); return;
    }

    items.innerHTML = cart.items.map(l => `
      <div class="cart-line">
        ${l.image ? `<img class="cl-img" src="${l.image}" alt="${l.product_title}">` : `<div class="ph" data-label="producto"></div>`}
        <div class="cl-info">
          <div class="cl-title">${l.product_title}</div>
          <div class="cl-sub">${l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : ''}</div>
          <div class="cl-bottom">
            <div class="qty">
              <button data-dec="${l.key}" aria-label="Quitar uno">−</button>
              <span>${l.quantity}</span>
              <button data-inc="${l.key}" data-q="${l.quantity}" aria-label="Añadir uno">+</button>
            </div>
            <div class="cl-price">${fmt(l.final_line_price)}</div>
          </div>
          <button class="cl-remove" data-rm="${l.key}">Eliminar</button>
        </div>
      </div>`).join('');

    foot.innerHTML = `
      <div class="cart-subtotal"><span>Subtotal</span><span>${fmt(cart.total_price)}</span></div>
      <p class="muted">Impuestos incluidos. Envío calculado en el checkout.</p>
      <a class="btn btn--full btn--lg" href="/checkout">Finalizar compra</a>`;

    $$('[data-inc]', items).forEach(b => b.addEventListener('click', () => changeLine(b.dataset.inc, Number(b.dataset.q) + 1)));
    $$('[data-dec]', items).forEach(b => b.addEventListener('click', () => {
      const span = b.parentElement.querySelector('span');
      changeLine(b.dataset.dec, Math.max(0, Number(span.textContent) - 1));
    }));
    $$('[data-rm]', items).forEach(b => b.addEventListener('click', () => changeLine(b.dataset.rm, 0)));
    updateShip(cart.total_price);
  }

  function updateShip(total) {
    const msg = $('#nd-ship-msg'); const fill = $('#nd-ship-fill');
    if (!msg) return;
    if (total >= FREE_SHIP) { msg.innerHTML = '🌿 <b>¡Genial! Tienes el envío gratis.</b>'; fill.style.width = '100%'; }
    else { const r = FREE_SHIP - total; msg.innerHTML = `Te faltan <b>${fmt(r)}</b> para el <b>envío gratis</b>.`; fill.style.width = Math.min(100, (total / FREE_SHIP) * 100) + '%'; }
  }

  /* ---------- ui bits ---------- */
  function initAccordions() {
    $$('.accordion .acc-head').forEach(h => h.addEventListener('click', () => h.closest('.accordion').classList.toggle('open')));
  }
  function initSteppers() {
    $$('[data-stepper]').forEach(st => {
      const out = $('[data-qval]', st);
      st.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return;
        let v = (parseInt(out.textContent, 10) || 1) + (b.dataset.step === 'up' ? 1 : -1);
        out.textContent = Math.max(1, v);
        const input = $('#nd-qty-input'); if (input) input.value = out.textContent;
      });
    });
  }
  function initAddButtons() {
    /* product cards: data-add-variant = variant id */
    $$('[data-add-variant]').forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      if (!btn.dataset.addVariant) return;
      addToCart(btn.dataset.addVariant, 1);
    }));
    /* PDP form */
    const form = $('#nd-product-form');
    if (form) form.addEventListener('submit', e => {
      e.preventDefault();
      const id = form.querySelector('[name="id"]').value;
      const qty = parseInt($('[data-qval]', form)?.textContent || '1', 10) || 1;
      addToCart(id, qty);
    });
  }
  function initTriggers() {
    $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
    $$('[data-open-menu]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openMenu(); }));
    $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
    $$('[data-menu-close]').forEach(b => b.addEventListener('click', closeMenu));
    scrim()?.addEventListener('click', closeAll);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  }
  function initReveal() {
    const els = $$('.reveal'); if (!els.length) return;
    const show = el => el.classList.add('in');
    const check = () => { const vh = innerHeight; els.forEach(el => { if (!el.classList.contains('in')) { const r = el.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) show(el); } }); };
    check(); addEventListener('scroll', check, { passive: true }); addEventListener('resize', check);
    setTimeout(() => els.forEach(show), 1600);
  }
  function initGallery() {
    $$('[data-gallery]').forEach(g => {
      const main = $('[data-gmain]', g);
      $$('[data-gthumb]', g).forEach(t => t.addEventListener('click', () => {
        $$('[data-gthumb]', g).forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        if (t.dataset.img) { main.style.backgroundImage = `url(${t.dataset.img})`; main.classList.remove('ph'); }
      }));
    });
  }
  /* PDP variant selector (radio buttons -> updates price + hidden id) */
  function initVariants() {
    const form = $('#nd-product-form'); if (!form) return;
    const priceEl = $('[data-price-now]'); const compareEl = $('[data-price-was]'); const saveEl = $('[data-price-save]');
    $$('[data-variant-opt]', form).forEach(opt => opt.addEventListener('click', () => {
      $$('[data-variant-opt]', form).forEach(x => x.classList.remove('sel'));
      opt.classList.add('sel');
      form.querySelector('[name="id"]').value = opt.dataset.variantOpt;
      if (priceEl && opt.dataset.price) priceEl.textContent = fmt(opt.dataset.price);
      if (compareEl) { if (opt.dataset.compare && Number(opt.dataset.compare) > Number(opt.dataset.price)) { compareEl.style.display = ''; compareEl.textContent = fmt(opt.dataset.compare); if (saveEl) { saveEl.parentElement.style.display = ''; saveEl.textContent = fmt(opt.dataset.compare - opt.dataset.price); } } else { compareEl.style.display = 'none'; if (saveEl) saveEl.parentElement.style.display = 'none'; } }
    }));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTriggers(); initAccordions(); initSteppers(); initAddButtons();
    initGallery(); initVariants(); initReveal(); refreshCart();
  });
})();
